import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './Toastmessage.html?raw';
import topic from 'dojo/topic';
import on from 'dojo/on';
import "./ToasterTypes";
import domConstruct from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import _WidgetBase from 'dijit/_WidgetBase';
import _TemplatedMixin from 'dijit/_TemplatedMixin';
import { TranslationHelpers } from "../../../more/Helpers";
import methodHooks from 'more/mdsMethodHooks';

class Toastmessage extends methodHooks(compose(_WidgetBase, _TemplatedMixin)) {
    templateString: any = template;

    private outerContainer: HTMLElement;
    private iconNode: HTMLSpanElement;
    private textNode: HTMLSpanElement;
    private buttonNode: HTMLElement;
    private txtClickToOpen: HTMLElement;
    private progressContainer: HTMLElement;
    private progressBar: HTMLElement;

    uniqueID: string = null;
    timeout: number | string = null;
    isDestroying: boolean = null;
    private _callbackHandle: any = null; // any suggestions for the type of dojo/on??


    //constructor(toastmessageParams: Toastmessageparams) {
    //    let self: any = this;
    //    self.inherited(arguments);
    //}

    setMessage(value: string | HTMLElement): void {
        if (!!value) {
            if (typeof (value) == "string") {
                value = this.tryTranslate(value);
                domAttr.set(this.textNode, "innerHTML", value);
            } else {
                domConstruct.place(value, this.textNode, "only");
            }

            domClass.toggle(this.domNode, "textContent", typeof (value) == "string");
        }
    }

    private tryTranslate(text: string): string {
        let translatedStr = null;
        if (!text) return text;
        try {
            if (window.translations) {
                translatedStr = window.translations[text];
            }
        }
        catch (ex) {

        }

        if (!translatedStr) translatedStr = text;

        return translatedStr;
    }

    //private setID (value:string):void {
    //    this.uniqueID = value;
    //}

    setIcon(value: toasterIcons | string): void {
        if (value && value.indexOf("class=", 0) == -1) {
            value = domConstruct.create("i", { className: value }).outerHTML;
        }
        if (!!value) {
            domAttr.set(this.iconNode, "innerHTML", value);
            domClass.remove(this.iconNode, "w3-hide");
        } else {
            domClass.add(this.iconNode, "w3-hide");
        }
    }

    private _setOptionsAttr(options: toastOptions) {
        this.setOptions(options);
    }
    setOptions(options: toastOptions): void{
        domClass.add(this.progressContainer, "w3-hide");
        domClass.remove(this.progressBar, "shrinkingBar");
        if (typeof (options) != "undefined") {
            //console.log("toast options", options);

            domAttr.set(this.buttonNode, "innerHTML", "");

            if (options.ID) {
                this.uniqueID = options.ID;
            }

            // mitgelieferte Buttons verarbeiten
            if (typeof (options.buttons) != "undefined") {
                var button: toastButton = null;
                for (var i = 0; i < options.buttons.length; i++) {
                    button = options.buttons[i];

                    //console.log("toast buttons", button);

                    this.drawButton(button.label, button.callback, button.icon);
                }
            }

            if (options.closeButton === true) {
                this.drawCloseButton();
            }

            // Kompatibilität: früher war das onclick ein Objekt mit dem Callback drin.
            // mittlerweile unnötig, aber damit ned alles beim Teufel ist...
            if (typeof (options.onClick) == "object" && options.onClick) {
                if (options.onClick.callback) {
                    options.onClick = options.onClick.callback;
                }
            }
            if (typeof (options.onClick) == "function") {
                domClass.add(this.outerContainer, "hoverBorder");


                if (this._callbackHandle != null) {
                    this._callbackHandle.remove();
                }
                //console.log("toastmessage onclick", options.onClick)
                let clickHandle = on(this.outerContainer, "click", options.onClick);
                this._callbackHandle = clickHandle;

                domClass.remove(this.txtClickToOpen, "w3-hide");


                on(this.outerContainer, "click", lang.hitch(this, function () { topic.publish("toastMessage/removeToast", this) }))
            }

            // zwischen 1 und 120s die schrumpfende Leiste einblenden:
            if ((options.timeout as number) >= 1000 && (options.timeout as number) <= 120000 && !options.hideTimeoutProgress === true) {
                this.progressBar.style.setProperty("--animationDuration", options.timeout + "ms");
                domClass.remove(this.progressContainer, "w3-hide");
                setTimeout(lang.hitch(this, domClass.add, this.progressBar, "shrinkingBar"), 2);
            }
        }
    }

    private drawButton(label: string, callBack: Function, icon?: toasterIcons | string, cyLabel?: string): void {
        //console.log("toastmessage drawbutton", innerHTML, callBack, icon);
        var outerDiv: HTMLElement = domConstruct.create("div", {
            style: {

            },
            "className": ""
        }, this.buttonNode);

        if (typeof (icon) != "undefined" && icon != null) {

            if (icon && icon.indexOf("class=", 0) == -1) {
                icon = domConstruct.create("i", { className: icon }).outerHTML;
            }

            if (label == null || label == "") {
                label = icon;
            } else {
                label = TranslationHelpers.tryTranslate(label);
                label = icon + "&nbsp;" + label;
            }

        }

        var button: HTMLElement = domConstruct.create("button", {
            className: "mds-button-base round hoverDark mediumTransparentBG secondaryText",
            innerHTML: label
        }, outerDiv);
        button.setAttribute("data-cy", "toastMessage:btn:" + (cyLabel || label || "btn"));

        if (typeof (callBack) == "function") {
            on(outerDiv, "click", function (evt) { evt.stopPropagation(); callBack(evt); });
        }

        domClass.remove(this.buttonNode, "w3-hide");

        // zumachen sollte jeder button
        on(outerDiv, "click", lang.hitch(this, function () { topic.publish("toastMessage/removeToast", this) }))
    }

    private drawCloseButton ():void {

        //var buttonIcon:any = domConstruct.create("i", { className: "fas fa-times", "aria-hidden": true });

        this.drawButton("", function () { }, toasterIcons.close, "close");
    }

    _setupSubscriptions() {
        ((Object.getPrototypeOf(Toastmessage.prototype) as any)._setupSubscriptions)?.apply(this, arguments as any); // base may not carry it (dojo inherited() was tolerant)
    }

    postMixInProperties() {
        super.postMixInProperties.apply(this, arguments as any); // standard code aus basisklasse
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        ///
        this.txtClickToOpen.innerHTML = this.tryTranslate("General_Toaster_ClickToOpen") || "#General_Toaster_ClickToOpen";
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        setTimeout(lang.hitch(this, domClass.remove, this.domNode, "w3-animate-bottom toastMessageGrowAnimation"), 1100);
    }

    destroy() {
        super.destroy.apply(this, arguments as any);
    }
}

export default mdsWidget(Toastmessage);
